import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Button, Icon,Input,Radio, } from 'antd';

import "./style.css";
import LayoutWrapper from '../../layouts/LayoutWrapper';
import ReduxComponent from '../ReduxComponent';
import {
	changeTemplateManagement,
	selectTemplateManagement,
} from '../../actions/work-report-actions';
import templateManagementService from '../../services/WorkReport/template-management-service';

const typeMap = [ "日报", "周报", "月报"];

class TemplateManagement extends ReduxComponent {

	state = {
		name:'',
		type_id:''
	}
	initReload = true;
	moduleName = "workReport";
	childModuleName = "templateManagement";

	actions = {
		changeAction: this.props.changeTemplateManagement,
		selectAction: this.props.selectTemplateManagement,
		// updateAction: this.props.updateTemplateManagement,
		deleteAction: templateManagementService.deleteTemplateManagement,
		// createAction: templateManagementService.createTemplateManagement,
	}

	column = [{
			title: '模版名称',
			dataIndex: 'name',
			key: 'name',
			className: 'table-global-head-short'
		},{
			title: '模版类型',
			dataIndex: 'type_id',
			key: 'type_id',
			className: 'table-global-head-short',
			render: text => typeMap[text-1]
		}, {
			title: '操作',
			dataIndex: 'actions',
			key: 'actions',
			className: 'table-global-head',
			render: (text, record, index) => {
				return (
					<Link to={"/report/template-management/" + record.id}>
						<Button icon="edit" size="small"
							className="row-action-btn">查看</Button>
					</Link>
				);
			} 
		}
	];
	setNameFilter = name =>{
		this.setState({name:name});
		this.actions.changeAction({
			name:name,
			type_id:this.state.type_id
		}, "reload");
	}
	setTypeFilter = event =>{
		this.setState({type_id:event.target.value});
		this.actions.changeAction({
			type_id:event.target.value,
			name:this.state.name
		}, "reload");
	} 
	render() {
		return (
			<div className="app-module-item">
				<div style={{marginBottom: "20px"}}>
					{this.props.access.templateManagement.c_value && <div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
						<Link to="/report/template-management/0">
							<Button type="primary">
								<Icon type="plus-circle-o" />
								<span>新增</span>
							</Button>
						</Link>
					</div>}
					{this.props.access.templateManagement.d_value && <div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
							<Button type="primary" onClick={this.publicDelete}>
								<Icon type="plus-circle-o" />
								<span>删除</span>
							</Button>
					</div>}
					<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
                        <Input.Search
                            placeholder="名称"
                            onSearch={this.setNameFilter}
                            style={{ width: 200 }}
                            enterButton />
                    </div>
					<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
						<Radio.Group defaultValue={this.props.workReport.dailyReportFilters.status}
							onChange={this.setTypeFilter}>
							<Radio.Button value="1">日报</Radio.Button>
							<Radio.Button value="2">周报</Radio.Button>
							<Radio.Button value="3">月报</Radio.Button>
						</Radio.Group>
					</div>
{/*					{this.props.access.templateManagement.d_value && <div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
						<Button type="primary" onClick={this.publicDelete}>
							<Icon type="delete" />
							<span>批量删除</span>
						</Button>
					</div>}*/}
					<div style={{clear: "both"}}></div>
				</div>
				{this.publicTableView()}
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		workReport: state.workReport
	}
}

const mapDispatchToProps = {
	changeTemplateManagement,
	selectTemplateManagement,
}

export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(TemplateManagement));




// WEBPACK FOOTER //
// ./src/routes/WorkReport/TemplateManagement.js